// extracted by mini-css-extract-plugin
export default {"containerDashboard":"MainDash_containerDashboard__l75kd","title":"MainDash_title__1di0G"};